import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'keyboard-admin';

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    // Set default language
    this.translate.setDefaultLang('en');
    this.translate.use('en');
  }
}
